import styled from 'styled-components/macro';

const Wrapper = styled(({className, children}) => (
    <div className={className}>
        {children}
    </div>
))`
  flex: 1 1 auto;
  min-width: 0;
  margin-right: 12px;
  @media only screen and (max-width: 780px) {
    & {
      margin-right: 0;
    }
  }
`;

export default Wrapper;
